import React from 'react';
import clsx from 'clsx';

export default function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}) {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center rounded-card border-2 border-dashed border-neutral-200 bg-neutral-50 px-6 py-16 text-center',
        className
      )}
    >
      {Icon && (
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-neutral-100 text-neutral-400">
          <Icon className="h-7 w-7" aria-hidden="true" />
        </div>
      )}

      {title && (
        <h3 className="text-base font-semibold text-neutral-900 font-heading">
          {title}
        </h3>
      )}

      {description && (
        <p className="mt-1 max-w-sm text-sm text-neutral-500">{description}</p>
      )}

      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
